import { Inertia } from '@inertiajs/inertia';
export default {
  components: {},
  props: {},
  watch: {
    '$store.loading': function $storeLoading() {
      if (!this.$store.loading) {
        this.$store.loadingText = 'Loading ...';
      }
    }
  },
  created: function created() {
    var _this = this;
    Inertia.on('start', function (event) {
      _this.$store.loading = true;
    });
    Inertia.on('finish', function () {
      return _this.$store.loading = false;
    });
  },
  methods: {}
};